import {
  IconFile,
  IconFileImage,
  IconFilePDF,
  IconFileWord,
} from '@xing-com/icons';

const ICONS: Record<string, React.FC> = {
  'text/plain': IconFileWord,
  'application/msword': IconFileWord,
  'application/vnd.oasis.opendocument.text': IconFileWord,
  'application/rtf': IconFileWord,
  'application/pdf': IconFilePDF,
  'image/jpeg': IconFileImage,
  'image/png': IconFileImage,
};

export const getIconByFileType = (fileType: string | null): React.FC => {
  return fileType ? (ICONS[fileType] ?? IconFile) : IconFile;
};
